import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalLink = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }

    // Remove trailing slash for root, keep path for others
    // Example: https://livingmedia.digital or https://livingmedia.digital/privacy
    const cleanPath = pathname === '/' ? '' : pathname;
    const canonicalUrl = `https://livingmedia.digital${cleanPath}`;
    
    link.setAttribute('href', canonicalUrl);
  }, [pathname]);

  return null;
};

export default CanonicalLink;